import { Language } from "@src/reducers/your-reducer";
import { ISO3LanguageCode } from "@src/types/user-management";

export const toISO2 = (lang: ISO3LanguageCode): Language => {
  switch (lang) {
    case "eng":
      return "en";
    case "deu":
      return "de";
    case "zho":
      return "zh";
    case "ita":
      return "it";
    case "spa":
      return "es";
    case "por":
      return "pt";
    case "nld":
      return "nl";
    case "tur":
      return "tr";
    default:
      return "en";
  }
};
